export enum AuthState {
    LOGGED_IN, 
    NOT_LOGGED_IN, 
    AUTHENTICATION_REQUIRED
}